var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01228 1.80431H3.60888V29.8724H5.01228V1.80431ZM2.60645 0.80188V30.8749H6.01472V0.80188H2.60645Z",
    fill: "#F6931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6359 23.0559V21.853H8.62131V23.0559H14.6359ZM15.6383 20.8506H7.61888V24.0584L15.6383 24.0584V20.8506Z",
    fill: "#F6931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4695 1.80431H27.0661V29.8724H28.4695V1.80431ZM26.0637 0.80188V30.8749H29.4719V0.80188H26.0637Z",
    fill: "#F6931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5646 3.70894H5.51348V2.70651H26.5646V3.70894Z",
    fill: "#F6931E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5646 6.11475H5.51348V5.11232H26.5646V6.11475Z",
    fill: "#F6931E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5526 5.61355V18.4447H20.5502V5.61355H21.5526Z",
    fill: "#F6931E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5357 5.61358L14.5357 21.452H13.5333L13.5333 5.61358H14.5357Z",
    fill: "#F6931E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72407 5.61358L9.72406 21.452H8.72163L8.72163 5.61358H9.72407Z",
    fill: "#F6931E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0515 24.6598C22.6016 24.6598 23.8583 23.4031 23.8583 21.853C23.8583 20.3028 22.6016 19.0462 21.0515 19.0462C19.5013 19.0462 18.2447 20.3028 18.2447 21.853C18.2447 23.4031 19.5013 24.6598 21.0515 24.6598ZM21.0515 25.6622C23.1553 25.6622 24.8607 23.9568 24.8607 21.853C24.8607 19.7492 23.1553 18.0437 21.0515 18.0437C18.9477 18.0437 17.2422 19.7492 17.2422 21.853C17.2422 23.9568 18.9477 25.6622 21.0515 25.6622Z",
    fill: "#F6931E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0512 22.6549C21.4941 22.6549 21.8532 22.2959 21.8532 21.853C21.8532 21.4101 21.4941 21.051 21.0512 21.051C20.6083 21.051 20.2493 21.4101 20.2493 21.853C20.2493 22.2959 20.6083 22.6549 21.0512 22.6549ZM21.0512 23.6574C22.0478 23.6574 22.8556 22.8495 22.8556 21.853C22.8556 20.8564 22.0478 20.0486 21.0512 20.0486C20.0547 20.0486 19.2469 20.8564 19.2469 21.853C19.2469 22.8495 20.0547 23.6574 21.0512 23.6574Z",
    fill: "#F6931E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.0e18d4a510b8abcd37ab3d1ddfcb8b61.svg";
export { ForwardRef as ReactComponent };